import type { SemanticTone } from '../tokens'

/*
 * Classes por cor semântica, escritas por extenso para o Tailwind encontrá-las no código.
 * Texto informativo fica em `ink`: as cores semânticas não atingem 4,5:1 sobre fundo claro
 * (âmbar, por exemplo, fica em 2,9:1), então elas vão no ícone, no fundo tingido ou na fita.
 */

/** Ícones e marcas na cor semântica. */
export const toneText: Record<SemanticTone, string> = {
  petroleo: 'text-petroleo',
  jade: 'text-jade',
  ambar: 'text-ambar',
  framboesa: 'text-framboesa',
  ardosia: 'text-ardosia',
}

/** Fundo tingido (chips, badges, avatares). */
export const toneSoftBg: Record<SemanticTone, string> = {
  petroleo: 'bg-petroleo/14',
  jade: 'bg-jade/14',
  ambar: 'bg-ambar/16',
  framboesa: 'bg-framboesa/14',
  ardosia: 'bg-ardosia/14',
}

/** Cor sólida (fitas de status, pontos de legenda). */
export const toneSolidBg: Record<SemanticTone, string> = {
  petroleo: 'bg-petroleo',
  jade: 'bg-jade',
  ambar: 'bg-ambar',
  framboesa: 'bg-framboesa',
  ardosia: 'bg-ardosia',
}
